export default __webpack_public_path__ + "static/media/osl.16165ff1.png";